import React, { Component } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, TrevorIcon } from '@trevor/ui-components';
import css from '../../css/module/billing.css';
import flex from '../../css/module/flex.css';
import nwCSS from '../../css/module/new-world.css';
import AjaxSpinner from '../AjaxSpinner';
import { get } from '../../util/helpers/ajax-helpers';

class HerokuBilling extends Component {
  constructor(props) {
    super(props);
    this.state = {
      name: null,
      url: null,
    };
  }

  componentDidMount() {
    const { isPanoply } = this.props;
    if (isPanoply) {
      this.setState({
        name: 'Panoply',
        url: 'https://platform.panoply.io/#/billing',
      });
    } else {
      get('loading heroku billing link', '/api/subscription/heroku').then(
        (json) => {
          this.setState({
            name: 'Heroku',
            url: json.url,
          });
        },
      );
    }
  }

  render() {
    if (!this.state.url) {
      return (
        <div className={flex.middle} style={{ height: '100vh' }}>
          <AjaxSpinner />
        </div>
      );
    }

    //
    // TODO
    //
    const isPayingCustomer = true;

    return (
      <div className={css.container}>
        <div className={css.inner}>
          <div className={css.titleContainer}>
            <h1>{isPayingCustomer ? 'Billing' : 'Activate subscription'}</h1>
          </div>
          <div className={css.section}>
            <div className={`${flex.row} ${flex.alignItemsCenter}`}>
              <div className={css.billingIcon}>
                <FontAwesomeIcon icon="gamepad" />
              </div>
              <span>
                {isPayingCustomer
                  ? `Manage your Trevor.io subscription via ${this.state.name}`
                  : `Upgrade in a couple of clicks via ${this.state.name}`}
              </span>
              &nbsp; &nbsp;
              <a href={this.state.url} target="_blank">
                <Button
                  className={nwCSS.notification}
                  icon={<TrevorIcon name="arrow-right" />}
                >
                  Go to {this.state.name}
                </Button>
              </a>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default HerokuBilling;
